import { render } from "./MailStatisticsDownloadPopup.vue?vue&type=template&id=0bae272b"
import script from "./MailStatisticsDownloadPopup.vue?vue&type=script&lang=js"
export * from "./MailStatisticsDownloadPopup.vue?vue&type=script&lang=js"

import "./MailStatisticsDownloadPopup.vue?vue&type=style&index=0&id=0bae272b&lang=css"

import exportComponent from "/home/forge/newsletter.norden.org/releases/74710130/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__